import { render, staticRenderFns } from "./vnowxquery.vue?vue&type=template&id=22e08382&scoped=true&"
import script from "./vnowxquery.vue?vue&type=script&lang=js&"
export * from "./vnowxquery.vue?vue&type=script&lang=js&"
import style0 from "./vnowxquery.vue?vue&type=style&index=0&id=22e08382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e08382",
  null
  
)

export default component.exports